import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/longterm2006.css';
import BgTop from '../images/Event/longterm2006/bg_top.png';
import BgBottom from '../images/Event/longterm2006/bg_bottom.png';
import InfoCaution from '../images/Event/longterm2006/info_caution.png';
import InfoMarketing from '../images/Event/longterm2006/info_marketing.png';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';
// import { StickyContainer, Sticky } from 'react-sticky';
import Sticky from 'react-sticky-el';

var _timer = null;

class Longterm2006 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenPopup: false,
      name: "",
      tel: "",
      isAgree: false,
      isVerifyPhone: false,
      isVerifyExpired: false,
      verifyNum: '',
      inputVerifyNum: '',
      verifyNumText: '',
      expireSec: 180,
      expireCount: 0,
      expireText: ''
    };
  }

  componentDidMount() {
    window.pageVisit("longterm", "2006");
  }

/**
   * 인증번호 발송
   */
  _sendVerifyNum = (e) => {
    if(this.state.isVerifyPhone) return;

    var name = this.state.name;
    if(!name) {
      Actions.alertOpen({msg: "이름을 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    var tel = this.state.tel;
    if(!tel) {
      Actions.alertOpen({msg: '연락처를 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(!Common.isPhoneNumberValidation(tel)) {
      Actions.alertOpen({msg: '연락처 형식이 올바르지 않습니다.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    Common.callApi('/verifyPhone', 'post', {memberPhone: tel, message: '[토즈 장기등록이벤트] 인증번호 ( ##### )를 입력 해주세요.'})
    .then(result => {
        if(result.resultCode === 'success') {
          this._stopVerifyTime();
          this.setState({ verifyNum: result.resultData.verifyNum });

          _timer = setInterval(() => {
            var _expireSec = this.state.expireCount - 1;
            if(_expireSec < 0) {
              this._stopVerifyTime();
              this.setState({
                expireText: '인증번호가 만료되었습니다.',
                isVerifyExpired: true
              });
              return;
            }
            this.setState({
              expireText: Common.secToMin(_expireSec),
              expireCount: _expireSec
            });
          }, 1000);

          this.setState({verifyNum: result.resultData.verifyNum });

          Actions.alertOpen({msg: '인증번호가 발송되었습니다.'}, [{type: 'ok', label: '확인'}]);
        } else {
          Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
        }
      }
    );
  }

  /**
   * 인증번호 입력 시간 타이머 stop
   */
  _stopVerifyTime = () => {
    clearInterval(_timer);
    this.setState({
      expireCount: 180,
      expireText: '',
      verifyNum: '',
      inputVerifyNum: '',
      isVerifyPhone: false,
      isVerifyExpired: false
    });
    _timer = null;
  }

  /**
   * 인증번호 check
   */
  _checkVerifyNum = () => {
    if(this.state.isVerifyPhone) return;

    var inputVerifyNum = this.state.inputVerifyNum;
    if(inputVerifyNum === '') {
      Actions.alertOpen({msg: '인증번호를 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(this.state.isVerifyExpired) {
      Actions.alertOpen({msg: '인증번호가 만료되었습니다.<br/>휴대번호 인증을 다시 진행해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(this.state.verifyNum !== inputVerifyNum) {
      Actions.alertOpen({msg: '인증번호가 올바르지 않습니다.'}, [{type: 'ok', label: '확인'}]);
      return false;
    } else {
      Actions.alertOpen({msg: '인증이 완료되었습니다.'}, [{type: 'ok', label: '확인'}]);
      this._stopVerifyTime();
      this.setState({ isVerifyPhone: true });
    }
  }

  /**
		 * 쿠폰발급 신청하기
		 */
  _doApply() {
    var name = this.state.name;
    var tel = this.state.tel;
    var isAgree = this.state.isAgree;

    if(!name) {
      Actions.alertOpen({msg: "이름을 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!tel) {
      Actions.alertOpen({msg: "연락처를 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(Common.checkExp(tel)) {
      Actions.alertOpen({msg: "숫자만 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!this.state.isVerifyPhone) {
      Actions.alertOpen({msg: '핸드폰 인증을 해주세요.'}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!isAgree) {
      Actions.alertOpen({msg: "마케팅 정보활용 동의를 체크해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    Common.callApi("/promotion/longterm", 'post', {name: name, tel: tel})
    .then(result => {
      if(result.resultCode === "success") {
        this.setState({ isOpenPopup: true });
        window.gtag_report_conversion();
        window.pageComplete("longterm", "2006");
      } else {
        Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  _renderPopup() {
    return (
      <div className="popupArea" onClick={() => {window.location.reload()}}>
        <div className="popupContentsArea">
        </div>
      </div>
    )
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont longterm" style={{background: '#30394a'}}>
              <div id="contents" style={{background: '#25284b'}}>
                <div><img src={BgTop} style={{width: '100%'}} /></div>
                
                <div className="info-cont" style={{textAlign: 'center', paddingBottom: '10%'}}>
			            <p className="title-main">쿠폰으로 할인받고, 토즈 이용하기</p>
                  <div style={{width: '100%', display: 'table', marginTop: '30px'}}>
                    <div style={{display: 'table-cell', textAlign: 'center'}}>
                      <input type="text" placeholder="이&nbsp;&nbsp;&nbsp;름" disabled={this.state.isVerifyPhone} onChange={(e) => this.setState({name: e.target.value})} />
                      <input type="tel" placeholder="연락처" disabled={this.state.isVerifyPhone} style={{margin: '8px 0'}} maxLength="11" onChange={(e) => this.setState({tel: e.target.value})} />
                      <div className="verifyArea">
                        <input type="tel" placeholder="인증번호" disabled={this.state.isVerifyPhone} className="verifyNum" maxLength="6" onChange={(e) => this.setState({inputVerifyNum: e.target.value})} />
                        <button className="request" onClick={() => this._sendVerifyNum()}>{_timer != null ? this.state.expireText : "인증번호요청"}</button>
                      </div>
                      <button className="confirm" onClick={() => this._checkVerifyNum()}>인증확인</button>
                    </div>
                  </div>

                  <img className="infoCaution" src={InfoCaution} />
                  <img className="infoMarketing" src={InfoMarketing} />

                  <p className="agreeArea">
                    <input type="checkbox" id="isAgree" onChange={e => this.setState({ isAgree: !this.state.isAgree })}  />
                    <label htmlFor="isAgree">&nbsp;&nbsp;동의합니다.</label>
                  </p>
                  <button className="apply" onClick={() => this._doApply()}>쿠폰발급 신청하기</button>
                </div>

                <p style={{textAlign: "center", color: "#a7a7a7", paddingBottom: "5%"}}>
                  (주)티스터디컴퍼니&nbsp;&nbsp;&nbsp;&nbsp;tsc_head@toz.co.kr
                </p>
                <div><img src={BgBottom} style={{width: '100%'}} /></div>
              </div>

              {this.state.isOpenPopup ? this._renderPopup() : ""}
            </div>
          </div>
        </div>

        <Sticky mode="bottom" stickyStyle={{ zIndex: 3 }}>
            <Link to="/experience/request"><div className="longterm experience"></div></Link>
        </Sticky>  
      </Fragment>
    )
  }
}

export default Longterm2006;